export default __webpack_public_path__ + "static/media/add-shopping-cart-blue.1d4a8f8f.svg";